import React from 'react';
import styled from 'styled-components';
import { Icon } from 'antd';

import { dateString } from 'utils/helpers';
import { countryMap } from 'utils/countries';
import { getChildPriceObj, isMultiTier, isRequireDeliveryLocation, isMatchPassportName, isRequireDate, isRequireMeetingPoint } from 'utils/product';
import { isRequireHotelName } from 'utils/booking';

const SummaryItem = styled.p`
  font-size: 14px;
  margin-bottom: 7px;
`;

const TotalPrice = styled.p`
  font-size: 18px;
  color: ${props => props.theme.green};
  font-weight: bold;
`;

const ReviewInfoContainer = styled.div`
  text-align: center;
`;

const SummaryIcon = styled(Icon).attrs({
  type: 'profile'
})`
  color: ${props => props.theme.orange};
  font-size: 100px;
  margin-bottom: 4px;
`;

const ReviewInfoText = styled.h2`
  font-size: 22px;
  color: ${props => props.theme.orange};
`;

const getQuantity = (book, product) => {
  if (isMultiTier(product)) {
    const selectedTier = product.multi_tier_prices.find(t => t.tier === book.selectedTier);
    return selectedTier.sub_tiers.map((st, idx) => `${book.subTier[idx]}x${st.name}`).join(', ');
  }
  const childPrice = getChildPriceObj(product.additional_options || []);
  if (childPrice) {
    return `${book.quantity}xAdult(s), ${book.childQuantity}xChild`;
  }
  return book.quantity;
};

const BookSummaryForm = props => {
  const { book, product, totalPrice } = props;
  let productDateLabel = 'Trip date';
  if (product.product_type === 'souvenir') productDateLabel = 'Delivery date';
  if (product.product_type === 'ticket') productDateLabel = 'Visit date';
  const customerName = `${isMatchPassportName(product) ? `${book.user.nameTitle} ` : ''}${book.user.firstName} ${book.user.lastName}`;
  return (
    <div>
      <ReviewInfoContainer>
        <SummaryIcon />
        <ReviewInfoText>Review your transaction</ReviewInfoText>
      </ReviewInfoContainer>
      <SummaryItem><b>Product: </b>{product.name}</SummaryItem>
      {isRequireDate(product) && <SummaryItem><b>{productDateLabel}: </b>{dateString(book.date.date, 'date')}</SummaryItem>}
      <SummaryItem><b>Quantity: </b>{getQuantity(book, product)}</SummaryItem>
      <SummaryItem><b>Customer name: </b>{customerName}</SummaryItem>
      <SummaryItem><b>Customer email: </b>{book.user.email}</SummaryItem>
      <SummaryItem><b>Customer mobile: </b>{book.user.phone}</SummaryItem>
      <SummaryItem><b>Customer country of passport: </b>{countryMap[book.user.country]}</SummaryItem>
      {isRequireMeetingPoint(product) &&
        <SummaryItem><b>Customer meeting point: </b>{book.user.meetingPoint}{isRequireHotelName(book) && `, ${book.user.hotelName}`}</SummaryItem>
      }
      {isRequireDeliveryLocation(product) && <SummaryItem><b>Delivery location: </b>Hotel {book.delivery.name}, Room {book.delivery.room}</SummaryItem>}
      <TotalPrice>Total Price: THB {totalPrice}</TotalPrice>
    </div>
  );
};

export default BookSummaryForm;



// WEBPACK FOOTER //
// ./src/components/Form/BookSummaryForm.js